import React, { Component } from 'react'
import Slider from 'react-slick'
import { Tile } from './Tile/Tile'
import InlineLoader from '../loaders/InlineLoader'
import classNames from 'classnames'
import styles from './TileCarousel.module.scss'
import tileStyles from './Tiles.module.scss'

class TileCarousel extends Component {
  state = {
    clientXonMouseDown: null,
    clientYonMouseDown: null
  }

  handleOnMouseDown(e) {
    this.setState({
      clientXonMouseDown: e.clientX,
      clientYonMouseDown: e.clientY
    })
    e.preventDefault()
  }

  handleOnClick(e, cb) {
    e.stopPropagation()
    if (
      this.state.clientXonMouseDown !== e.clientX ||
      this.state.clientYonMouseDown !== e.clientY
    ) {
      e.preventDefault()
    } else {
      cb()
    }
  }

  render() {
    const settings = {
      className: styles.tiles_carousel,
      infinite: false,
      dots: true,
      speed: 250,
      initialSlide: 0,
      slidesToShow: this.props.slidesToShow || 3,
      swipeToSlide: true,
      focusOnSelect: false,
      arrows: true,
      beforeChange: this.startDragging,
      afterChange: this.stopDragging,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.props.lgSlidesToShow || 3
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: this.props.mdSlidesToShow || 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: this.props.smSlidesToShow || 1
          }
        }
      ]
    }
    if (!this.props.products) {
      return <InlineLoader />
    }
    return (
      <div className={classNames(tileStyles.tiles, styles.slider)}>
        <Slider ref={(c) => (this.slider = c)} {...settings}>
          {this.props.products.map((product) => (
            <Tile
              key={product.slug}
              id={product.slug}
              product={product}
              onMouseDown={(e) => this.handleOnMouseDown(e)}
              clickIntercept={(e, cb) => this.handleOnClick(e, cb)}
            />
          ))}
        </Slider>
      </div>
    )
  }
}

export default TileCarousel
